import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class QueueCountService {
  private readonly _pending = signal<number>(0);
  readonly pending = this._pending.asReadonly();

  setPending(count: number): void {
    this._pending.set(Math.max(0, count));
  }
}
